import React from 'react';

import Header from '@hydra/common/app/Header';
import Footer from '@hydra/common/app/Footer';
import LayoutShell from '@hydra/common/shell/LayoutShell';
import { Shell } from '@hydra/types/shell';
import { useTheme } from '@material-ui/core/styles';

interface HeaderFooterShellProps extends Shell {
  HeaderProps?: object
  FooterProps?: object
}

export default function HeaderFooterShell ({
  className,
  children,
  hideFooter = false,
  hideHeader = false,
  bgColor: bgColorProp,
  HeaderProps = {},
  FooterProps = {}
}: HeaderFooterShellProps) {
  const theme = useTheme();
  const bgColor = bgColorProp || theme.palette.background.default;

  return (
    <>
      {!hideHeader && <Header {...HeaderProps} />}
      <LayoutShell sideNav={false} bgColor={bgColor} className={className}>
        {children}
      </LayoutShell>
      {!hideFooter && <Footer bgColor={bgColor} {...FooterProps} />}
    </>
  );
}
